module.exports = __webpack_public_path__ + "static/img/M-3.8cd917f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mzhongfu/M-3.png
// module id = Z3fq
// module chunks = 0